import barba from '@barba/core';

class ProjectsList extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    const projects_target = this.querySelector('#projects-list');
    if (!projects_target) { return }

    let projects_wrapper = this.querySelector('#projects-list');
    const more_button = this.querySelector('#projects-load-more');
    const base_path = this.dataset.basePath;
    // const page_url = this.dataset.pageUrl;

    const fetchMoreprojects = async () => {
      let next_page = parseInt(projects_target.getAttribute('data-next-page'));
      let url = `${base_path}/page:${next_page}`;
      try {
        const response = await fetch(url);
        const { html, more, next_page } = await response.json();

        const last_child = projects_target.children[projects_target.children.length - 1];

        projects_target.insertAdjacentHTML('beforeend', html);
        projects_target.dataset.nextPage = next_page;

        // ScrollTrigger.refresh();

        if (last_child.nextElementSibling) {
          last_child.nextElementSibling.scrollIntoView({
            behavior: 'smooth',
          });
        }

        more_button.classList.toggle('opacity-0', !more);
        more_button.classList.toggle('invisible', !more);
        more_button.classList.toggle('opacity-100', more);
        more_button.classList.toggle('visible', more);
        more_button.disabled = !more;
        more_button.ariaDisabled = !more;

        setTimeout(() => {
          projects_wrapper.classList.remove('opacity-70');
        }, 200);
      } catch (error) {
        console.log('Fetch error: ', error);
      }
    }

    more_button.addEventListener('click', () => {
      more_button.disabled = true;
      more_button.ariaDisabled = true;
      projects_wrapper.classList.add('opacity-70');
      setTimeout(() => {
        fetchMoreprojects()
      }, 200);
    });
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('projects-list', ProjectsList);
}
